
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/paymentterms",
      function () {
        return require("private-next-pages/paymentterms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/paymentterms"])
      });
    }
  